(function () {
  const SWIPE_THRESHOLD = 40;

  function setupHero(root) {
    const slides = Array.from(root.querySelectorAll('[data-slide]'));
    const dots = Array.from(root.querySelectorAll('[data-dot]'));
    const list = root.querySelector('.hf-hero__slides');

    if (!slides.length || !list) return;

    let index = Math.max(0, slides.findIndex(s => s.classList.contains('is-active')));
    if (index === -1) index = 0;

    function setHeight() {
      // active slide is "position: relative", others absolute
      const active = slides[index];
      if (!active) return;
      // temporarily ensure visible for correct measurement (in case of edge states)
      const h = active.offsetHeight;
      if (h) list.style.height = h + 'px';
    }

    function goTo(i) {
      const next = (i + slides.length) % slides.length;
      if (next === index) return;

      slides[index].classList.remove('is-active');
      slides[index].setAttribute('aria-hidden', 'true');

      slides[next].classList.add('is-active');
      slides[next].setAttribute('aria-hidden', 'false');

      if (dots.length) {
        dots.forEach((d, di) => {
          const active = di === next;
          d.classList.toggle('is-active', active);
          d.setAttribute('aria-current', active ? 'true' : 'false');
        });
      }

      index = next;
      // allow reflow for height after opacity transition starts
      requestAnimationFrame(setHeight);
    }

    // Dot clicks
    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const i = Number(dot.getAttribute('data-index'));
        if (!Number.isNaN(i)) goTo(i);
      });
    });

    // Arrow controls
    const prevBtn = root.querySelector('[data-prev]');
    const nextBtn = root.querySelector('[data-next]');

    if (prevBtn) {
    prevBtn.addEventListener('click', () => goTo(index - 1));
    }

    if (nextBtn) {
    nextBtn.addEventListener('click', () => goTo(index + 1));
    }

    // Swipe
    let startX = 0;
    let startY = 0;
    let dragging = false;

    function onStart(e) {
      const t = e.touches ? e.touches[0] : e;
      startX = t.clientX;
      startY = t.clientY;
      dragging = true;
    }

    function onEnd(e) {
      if (!dragging) return;
      dragging = false;

      const t = e.changedTouches ? e.changedTouches[0] : e;
      const dx = t.clientX - startX;
      const dy = t.clientY - startY;

      // ignore mostly-vertical gestures (scroll)
      if (Math.abs(dy) > Math.abs(dx)) return;

      if (dx > SWIPE_THRESHOLD) goTo(index - 1);
      else if (dx < -SWIPE_THRESHOLD) goTo(index + 1);
    }

    // Attach swipe handlers to the whole hero area
    root.addEventListener('touchstart', onStart, { passive: true });
    root.addEventListener('touchend', onEnd, { passive: true });

    // Height on load + resize
    setHeight();
    window.addEventListener('resize', () => requestAnimationFrame(setHeight));

    // If images load after, update height
    slides.forEach(s => {
      s.querySelectorAll('img').forEach(img => {
        img.addEventListener('load', () => requestAnimationFrame(setHeight), { once: true });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-hf-hero-fade]').forEach(setupHero);
  });
})();